export default __webpack_public_path__ + "static/media/Unifi.b4aa97e3.svg";